import { IScriptExecuteBehavior } from "./IScriptExecuteBehavior";

export interface IScriptExecuteBehaviorSpecifiable<T extends IScriptExecuteBehavior = IScriptExecuteBehavior> {
  scriptExecuteBehavior: T;
}

export function instanceOfIScriptExecuteBehaviorSpecifiable<T extends IScriptExecuteBehavior = IScriptExecuteBehavior>(instance: any): instance is IScriptExecuteBehaviorSpecifiable<T> {
  return instance
    && (instance.scriptExecuteBehavior !== undefined);
}
